var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"tr"},[_vm._t("default"),(_vm.showTargeting)?_c('TargetingBlock',{staticClass:"targeting",attrs:{"adSet":_vm.adSet,"reach":true,"step":false}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }